import { Inject, Component } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  first_name: string;
  last_name: string;
  override:string;
}
@Component({
    selector: 'duplicate-override-dialog',
    templateUrl: 'duplicate-override-dialog.component.html',
    standalone: false
})
export class DuplicateOverrideDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DuplicateOverrideDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onClick(value): void {
    this.dialogRef.close(value);
  }

}



